import React from "react"
import { Flex, Box, Text, Link } from "rebass"

import SocialButton from "../buttons/SocialButton"
import RowWrapper from "./RowWrapper"
import ButtonsNav from "./ButtonsNav"

const RowFooterComponent = ({ data }) => {
  const {
    title,
    titleHeadingTag,
    text,
    alignItems,
    justifyContent,
    buttonsButtons,
    socialLinks
  } = data

  return (
    <RowWrapper {...data}>

      <Flex
        flexDirection={["column", null, "row"]}
        justifyContent={ justifyContent }
        alignItems={ alignItems }
        pt={[0, null, 4, 5]}
        px={['15px', null, 0]}
      >

        <Box
          as="aside"
          width={[1, null, 1/2]}
        >
          {title && <Text as={titleHeadingTag} mb={3}>{title}</Text>}
          {buttonsButtons && <ButtonsNav
            data={buttonsButtons}
            pt={1}
            pb={4}
            sx={{
              display: "flex",
              flexDirection: ["column", null, null, "row"],
              alignItems: "flex-start",
              '@media (max-width: 991px)': {
                '& > a': {
                  marginLeft: 0,
                  marginRight: 0,
                }
              },
              '& > a::after': {
                content: "none",
              }
            }}
          />}
          {text && <Box dangerouslySetInnerHTML={{ __html: text }} lineHeight="heading" fontFamily="heading" fontSize={1} textAlign={justifyContent} />}
        </Box>

        <Flex
          as="aside"
          width={[1, null, '50%']}
          pt={[4, null, 0]}
          pl={[0, null, 4, null, 6]}
          pb={[0, null, '12px', null, 0]}
          flexDirection={["column", null, null, null, "row"]}
          alignItems={["flex-start", null, "flex-end", null, "center"]}
          justifyContent="space-between"
        >
          {socialLinks && (
            <Flex as="nav" pb={[4, null, null, 3, 0]}>
              {socialLinks.map((link, index, array) => {
                return <SocialButton
                  key={index}
                  href={link.url}
                  title={link.label}
                  icon={link.icon.sourceUrl}
                  ml={index > 0 ? [2, null, 1] : 0}
                  mr={index < array.length - 1 ? [2, null, 1] : 0}
                />
              })}
            </Flex>
          )}

          <Link
            href="https://www.esma-3d.ca/"
            rel="noopener"
            variant="buttons.link"
            color={"text"}
            fontFamily={"heading"}
            fontSize={["28px", null, '32px', 5]}
            fontWeight={"body"}
            sx={{
              lineHeight: 1.19047619,
              textDecoration: "none",
            }}
          >ESMA-3D.CA</Link>
        </Flex>

      </Flex>
    </RowWrapper>
  )
}

export default RowFooterComponent
